import { instance, objectToParams } from './api';

export const getProducts = (args) => instance.get(`/api/v1/products?${objectToParams(args)}`);

export const getProdutById = (id) => instance.get(`/api/v1/products/${id}`);

export const getProductByBarcode = (barcode) => getProducts({ s: barcode }).then(({ data }) => data.data.shift());

// Filtros del catálogo. Acepta opcionalmente un género de catálogo
// ('Hombre' | 'Mujer') para acotar categorías/subcategorías a ese género.
export const getFilters = (gender) =>
  instance.get(`/api/v1/products/filters${gender ? `?gender=${encodeURIComponent(gender)}` : ''}`);

// Helper específico para la captación de leads: devuelve solo el array de
// nombres de categorías del catálogo para un género dado ('Hombre' | 'Mujer').
export const getProductCategoriesByGender = (gender) =>
  getFilters(gender).then(({ data }) => {
    const cats = (data.filters || []).find((f) => f.slug === 'categories');
    return cats?.options || [];
  });

export const postFileEPH = (file) => instance.post(`/api/v1/sells/files/eph`, file);

export const postFileUpcEPH = (file) => instance.post(`/api/v1/products/files/eph/upc`, file);

// Tags distintos ya usados en el catálogo, para autocompletar en el formulario
export const getProductTags = () => instance.get('/api/v1/products/tags');

// CRUD Producto padre
export const createProduct = (data) => instance.post('/api/v1/products', data);
export const updateProduct = (id, data) => instance.put(`/api/v1/products/${id}`, data);

// Validación previa del alta (dry-run: no escribe nada).
// Responde siempre 200 con { valid, errors: [{ field, index?, message }] }.
// Sirve para pintar los errores campo a campo sin perder el formulario.
export const validateProduct = (data) => instance.post('/api/v1/products/validate', data);

// CRUD Variantes
export const createVariant = (productId, data) => instance.post(`/api/v1/products/${productId}/variants`, data);
export const updateVariant = (productId, variantId, data) =>
  instance.put(`/api/v1/products/${productId}/variants/${variantId}`, data);
export const deleteVariant = (productId, variantId) =>
  instance.delete(`/api/v1/products/${productId}/variants/${variantId}`);

// Reclasificación / reconciliación de mercancía entre familias (cuentas 480 / 390)
// data reclassify:        { targetProductId, depositId, lines:[{ sourceBarcode, targetBarcode, qty }] }
// data reclassify-losses: { targetProductId, lines:[{ sourceBarcode, targetBarcode, qty }] }
// data reconcile-losses:  { lines:[{ deficitBarcode, surplusBarcode, qty }] }
export const postReclassify = (id, data) => instance.post(`/api/v1/products/${id}/reclassify`, data);
export const postReclassifyLosses = (id, data) => instance.post(`/api/v1/products/${id}/reclassify-losses`, data);
export const postReconcileLosses = (id, data) => instance.post(`/api/v1/products/${id}/reconcile-losses`, data);

// ALIAS DE CÓDIGO DE BARRAS
// Redirigen un EAN que llega de fuera (normalmente el de EPH) al EAN de la variante
// viva de la familia, para que la venta caiga donde entra la mercancía.
export const getProductAliases = (id) => instance.get(`/api/v1/products/${id}/aliases`);
export const postProductAlias = (id, data) => instance.post(`/api/v1/products/${id}/aliases`, data);
export const putProductAlias = (id, aliasId, data) =>
  instance.put(`/api/v1/products/${id}/aliases/${aliasId}`, data);
export const deleteProductAlias = (id, aliasId) => instance.delete(`/api/v1/products/${id}/aliases/${aliasId}`);

// IMAGES
export const uploadProductImages = (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('images[]', file));
  return instance.post('/api/v1/products/images', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const hydrateFilters = (filters) => {
  const search = new URLSearchParams(window.location.search);

  if (search.has('s') && filters.s) {
    filters.s.value = search.get('s');
  }

  Object.keys(filters).forEach((k) => (!filters[k].value ? (filters[k].value = search.get(k)) : null));

  return getFilters()
    .then(({ data }) => {
      data.filters.forEach((filter) => {
        filters[filter.slug] = { ...filter, ...filters[filter.slug] };
        filters[filter.slug].value = search.get(filter.slug);
      });

      return filters;
    })
    .catch((e) => console.error(e));
};

// Historial de movimientos de la familia (tab "Historial" de la ficha):
// timeline contable con saldos acumulados por barcode.
export const getProductHistory = (id) => instance.get(`/api/v1/products/${id}/history`);
